/*@ngInject*/
const DataItemsGroupController = function ($rootScope, $scope, $element, $timeout,
                                           localization, browserUtil, dataSetManagementUtil,
                                           uuidUtil, configurationConstant, dataSetEditorModel,
                                           currentUserModel, authorizationConstants) {

    $element.addClass('dataItemsGroup');

    localization.getTranslationByKey('dataItemsGroup').then(function (translations) {

        var shiftSelectPivotId = null,
            timeoutList = [];

        this.isReadOnly = !currentUserModel.hasAuthorization(authorizationConstants.MANAGE_DATASETS);

        this.init = function () {
            if (_.isNil(this.dataitemsGroup.items)) {
                this.dataitemsGroup.items = [];
            }

            this.groupNamePlaceholder = _.get(translations, 'groupNamePlaceholder');
            this.dataItemLabelPlaceholder = _.get(translations, 'table.row.labelPlaceholder');
            this.dataItemValuePlaceholder = _.get(translations, 'table.row.valuePlaceholder');
            this.dataItemDefaultValuePlaceholder = _.get(translations, 'table.row.defaultValuePlaceholder');

            this.buildTooltips();
            if (!this.isReadOnly) {
                this.addNewRowIfLastRowIsValid();
            }
        };

        this.buildTooltips = function () {
            _.each(this.dataitemsGroup.items, function (dataItemView) {
                if (!_.isNil(dataItemView.dataItem.name) && dataItemView.dataItem.name.length > 45) {
                    dataItemView.labelTooltip = dataItemView.dataItem.name;
                } else {
                    dataItemView.labelTooltip = '';
                }

                if (!_.isNil(dataItemView.dataItem.value) && dataItemView.dataItem.value.length > 45) {
                    dataItemView.valueTooltip = dataItemView.dataItem.value;
                } else {
                    dataItemView.valueTooltip = '';
                }
            });
        };

        this.addNewRowIfLastRowIsValid = function () {
            var emptyDataitems = this.dataitemsGroup.items.length === 0,
                lastRowIsValid = false,
                lastRow,
                dataItem;

            if (!emptyDataitems) {
                lastRow = _.last(this.dataitemsGroup.items);
                lastRowIsValid = dataSetManagementUtil.isValidDataItem(lastRow.dataItem);
            }

            if (emptyDataitems || lastRowIsValid) {
                dataItem = dataSetEditorModel.addDataItem(this.datasetName, this.dataitemsGroup.name);
                this.dataitemsGroup.items.push({
                    id: dataSetManagementUtil.generateUUID(),
                    groupId: this.dataitemsGroup.id,
                    dataSetName: this.dataitemsGroup.dataSetName,
                    dataItem: dataItem
                });
            }
        };

        this.removeEmptyLastRows = function () {
            var indexOfLastEmptyRow = -1,
                totalEmptyRows = 0;

            // Backwards-iterate through the data item views, removing the empty items from the model until we encounter a non-empty item
            // Store the total empties found along with the index of the last empty, for use below, splicing out the views
            _.forEachRight(this.dataitemsGroup.items, function (dataItemView, index) {
                var isEmptyDataItem = dataSetManagementUtil.isEmptyDataItem(dataItemView.dataItem);

                if (isEmptyDataItem) {
                    indexOfLastEmptyRow = index;
                    totalEmptyRows++;
                    dataSetEditorModel.removeDataItem(this.datasetName, dataItemView.dataItem);
                } else {
                    return false;
                }
            }.bind(this));

            this.dataitemsGroup.items.splice(indexOfLastEmptyRow, totalEmptyRows);
        };

        this.onDeleteClicked = function () {
            this.notifyDeleteClick();
        };

        this.onGroupNameBlur = function (event) {
            _.each(this.dataitemsGroup.items, function (dataItemView) {
                dataItemView.dataItem.grouping = this.dataitemsGroup.name;
            }.bind(this));
            if (this.currentFocusedValue !== event.currentTarget.value) {
                $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
            }
            this.buildTooltips();
        };

        this.onDataItemBlur = function (event, dataItemView) {
            var items = [];
            if (this.currentFocusedValue !== dataItemView.dataItem.value) {
                if (dataSetManagementUtil.isEmptyDataItem(dataItemView.dataItem)) {
                    _.each(this.dataitemsGroup.items, function (itemView) {
                        if (!dataSetManagementUtil.isEmptyDataItem(itemView.dataItem)) {
                            items.push(itemView);
                        }
                    });
                    this.dataitemsGroup.items = items;
                }
            }
            this.buildTooltips();
            this.removeEmptyLastRows();
            this.addNewRowIfLastRowIsValid();
        };

        this.onDataItemsGroupDragHandleMouseOver = function () {
            this.dataitemsGroup.draggable = true;
        };

        this.onDataItemsGroupDragHandleMouseLeave = function () {
            // Put this on a short timeout to allow for a drag to start if the drag is pulled and leaves the element before the
            // official drag start event fires.
            timeoutList.push($timeout(function () {
                this.dataitemsGroup.mouseDown = false;
                this.dataitemsGroup.draggable = false;
            }.bind(this), 100));
        };

        this.onDataItemsGroupDragHandleMouseDown = function (event) {
            if (event.button === 0) { // Left click only
                this.dataitemsGroup.mouseDown = true;
            }
        };

        this.onDataItemsGroupSelected = function (event) {
            if (event.button === 0) { // Left click only
                if (event.ctrlKey) {
                    this.dataitemsGroup.selected = !this.dataitemsGroup.selected;
                } else {
                    this.dataitemsGroup.selected = true;
                }

                this.notifyDataItemsGroupSelectedOrUnselected();
            }
        };

        this.onDataItemDragHandleMouseOver = function (dataItemView) {
            var isValidDataItem = dataSetManagementUtil.isValidDataItemForEvaluation(dataItemView.dataItem);
            if (isValidDataItem) {
                dataItemView.draggable = true;
            }
        };

        this.onDataItemDragHandleMouseLeave = function (dataItemView) {
            // Put this on a short timeout to allow for a drag to start if the drag is pulled and leaves the element before the
            // official drag start event fires.
            timeoutList.push($timeout(function () {
                dataItemView.mouseDown = false;
                dataItemView.draggable = false;
            }.bind(this), 100));
        };

        this.onDataItemDragHandleMouseDown = function (event, dataItemView) {
            var isValidDataItem;

            if (event.button === 0) { // Left click only
                isValidDataItem = dataSetManagementUtil.isValidDataItemForEvaluation(dataItemView.dataItem);

                if (isValidDataItem) {
                    dataItemView.mouseDown = true;
                }
            }
        };

        this.onDataItemSelected = function (event, dataItemView) {
            var isValidDataItem,
                shiftSelectPivot = null;

            if (event.button === 0) { // Left click only
                isValidDataItem = dataSetManagementUtil.isValidDataItemForEvaluation(dataItemView.dataItem);

                if (event.ctrlKey) {
                    dataItemView.selected = !dataItemView.selected;
                } else if (event.shiftKey) {
                    if (!_.isNil(shiftSelectPivotId)) {
                        shiftSelectPivot = _.find(this.dataitemsGroup.items, function (dataItemView) {
                            return dataItemView.id === shiftSelectPivotId;
                        });
                    }

                    if (_.isNil(shiftSelectPivot)) {
                        if (isValidDataItem) {
                            dataItemView.selected = true;
                            shiftSelectPivotId = dataItemView.id;
                        }
                    } else {
                        if (dataItemView.dataItem.ordering < shiftSelectPivot.dataItem.ordering) {
                            _.each(this.dataitemsGroup.items, function (itemView) {
                                var isValid = dataSetManagementUtil.isValidDataItemForEvaluation(itemView.dataItem);

                                if (isValid &&
                                    itemView.dataItem.ordering >= dataItemView.dataItem.ordering &&
                                    itemView.dataItem.ordering <= shiftSelectPivot.dataItem.ordering) {
                                    itemView.selected = true;
                                } else {
                                    itemView.selected = false;
                                }
                            });
                        } else if (dataItemView.dataItem.ordering > shiftSelectPivot.dataItem.ordering) {
                            _.each(this.dataitemsGroup.items, function (itemView) {
                                var isValid = dataSetManagementUtil.isValidDataItemForEvaluation(itemView.dataItem);

                                if (isValid &&
                                    itemView.dataItem.ordering >= shiftSelectPivot.dataItem.ordering &&
                                    itemView.dataItem.ordering <= dataItemView.dataItem.ordering) {
                                    itemView.selected = true;
                                } else {
                                    itemView.selected = false;
                                }
                            });
                        } else {
                            _.each(this.dataitemsGroup.items, function (itemView) {
                                itemView.selected = false;
                            });

                            dataItemView.selected = true;
                        }
                    }
                } else {
                    if (isValidDataItem) {
                        _.each(this.dataitemsGroup.items, function (itemView) {
                            itemView.selected = false;
                        });

                        dataItemView.selected = true;
                        shiftSelectPivotId = dataItemView.id;
                    }
                }

                this.notifyDataItemSelectedOrUnselected();
            }
        };

        this.onTextInputFocused = function (event) {
            this.currentFocusedValue = event.currentTarget.value;
            this.notifyTextInputFocused();
        };

        this.onDataItemChange = function () {
            var previouslyUnsaved = dataSetEditorModel.hasUnsavedChanges(this.datasetName);
            // no need to broadcast more than once, otherwise event will broadcast on every key stroke
            if (!previouslyUnsaved) {
                dataSetEditorModel.setUnsavedChanges(this.datasetName, /*hasUnsavedChanges*/ true);
                $rootScope.$broadcast(configurationConstant.event.DATA_SET_ITEMS_GROUP_UPDATED);
            }
        };

        this.$onChanges = function (changes) {
            var anyItemsSelected = _.some(this.dataitemsGroup.items, function (dataItemView) {
                return dataItemView.selected === true;
            });
            if (!anyItemsSelected) {
                shiftSelectPivotId = false;
            }

            this.removeEmptyLastRows();
            this.addNewRowIfLastRowIsValid();
        };

        $scope.$on(configurationConstant.event.DATA_SET_ITEMS_GROUP_DRAG_DROP_FROM_UNSELECTED_GROUP, function (event, data) {
            var mockMouseEvent;

            if (data.dataItemsGroupId === this.dataitemsGroup.id) {
                mockMouseEvent = {
                    button: 0,
                    ctrlKey: false,
                    shiftKey: false
                };

                timeoutList.push($timeout(function () {
                    this.onDataItemsGroupSelected(mockMouseEvent);
                }.bind(this), 0));
            }
        }.bind(this));

        $scope.$on(configurationConstant.event.DATA_SET_ITEM_DRAG_DROP_FROM_UNSELECTED_ROW, function (event, data) {
            var dataItemView,
                mockMouseEvent;

            if (data.dataItemsGroupId === this.dataitemsGroup.id) {
                dataItemView = _.find(this.dataitemsGroup.items, function (dataItemView) {
                    return dataItemView.id === data.dataItemId;
                });

                mockMouseEvent = {
                    button: 0,
                    ctrlKey: false,
                    shiftKey: false
                };

                timeoutList.push($timeout(function () {
                    this.onDataItemSelected(mockMouseEvent, dataItemView);
                }.bind(this), 0));
            }
        }.bind(this));

        $scope.$on(configurationConstant.event.DATA_SET_ITEM_GROUP_SET_SHIFT_SELECT_PIVOT, function (event, dataItemView) {
            if (dataItemView.groupId === this.dataitemsGroup.id) {
                shiftSelectPivotId = dataItemView.id;
            } else {
                shiftSelectPivotId = null;
            }
        }.bind(this));

        $scope.$on('$destroy', function () {
            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });

        this.init();
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('dataItemsGroupController', DataItemsGroupController);
